import { render, staticRenderFns } from "./CompareOverview.vue?vue&type=template&id=23483a5f&"
import script from "./CompareOverview.vue?vue&type=script&lang=js&"
export * from "./CompareOverview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports